import { useEffect, useState } from 'react';
import { getArticle, publishArticle } from '../../service/article';
import { useUser } from '../../context/UserProvider';
import { Button } from 'primereact/button';
import './Article.scss';

function Article() {
    const [news, setNews] = useState({});
    const { user, setErrorState } = useUser();
    useEffect(() => {
        console.log("User:", user);
        const queryParams = new URLSearchParams(window.location.search);
        const id = queryParams.get('id');
        getArticle(id)
            .then(response => {
                setNews({ ...response.data.data });
            })
            .catch(error => {
                setErrorState("Failed to fetch article");
            });
    }, [])

    const handlePublish = () => {
        publishArticle(news.id)
            .then(response => {
                if (response.status === 200) {
                    setErrorState("Article published successfully");
                    window.location.href = '/admin';
                } else {
                    setErrorState("Failed to publish article");
                }
            })
            .catch(error => {
                setErrorState("Failed to publish article");
            })
    }

    return (
        <>
            <div className='article-main'>
                <h1 className='article-title'>{news.title}</h1>
                <div className='article-details'>
                    <p><strong>Author:</strong> {news.authorName || 'Ankur Tyagi'}</p>
                    <p><strong>Published:</strong> {new Date(news.lastModified).toLocaleDateString('en-IN')}</p>
                </div>
                <div className='article-thumbnail'>
                    <img src={news.thumbnailUrl} alt="Thumbnail" className='article-thumbnail' />
                </div>
                <ArticleContent content={news.content} />
            </div>
            {
                ( user!=null && user.role === 'ROLE_ADMIN' && news.status=='DRAFT') && 
                <div className='article-actions'>
                    <Button onClick={() => handlePublish()}>Publish</Button>
                </div>
            }
        </>
    )
}

function ArticleContent({ content }) {
    return <div className='article-content' dangerouslySetInnerHTML={{ __html: content }} />;
}

export default Article;